function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  InsightsGroup: true
};
exports.InsightsGroup = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _components = require("../../components");
var _utils = require("../../utils");
var _Data = require("./Data");
Object.keys(_Data).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Data[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Data[key];
    }
  });
});
var _styles = require("./styles");
var _utils2 = require("./utils");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["item", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var InsightsGroup = exports.InsightsGroup = (0, _react.memo)(function (_ref) {
  var _insights$steps, _insights$steps$total;
  var _ref$controller = _ref.controller,
    controller = _ref$controller === void 0 ? new _Data.InsightsGroupController() : _ref$controller;
  var _controller$useContro = controller.useController(),
    insights = _controller$useContro.insights,
    isLoading = _controller$useContro.isLoading;
  var _useInsightsGroupUtil = (0, _utils2.useInsightsGroupUtils)(),
    formatFootprints = _useInsightsGroupUtil.formatFootprints,
    formatImpacts = _useInsightsGroupUtil.formatImpacts,
    updateFootprintData = _useInsightsGroupUtil.updateFootprintData,
    updateImpactData = _useInsightsGroupUtil.updateImpactData,
    goalToSvgMap = _useInsightsGroupUtil.goalToSvgMap;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    footprintPageLinkUrl = _useContext.footprintPageLinkUrl,
    insightsPageLinkUrl = _useContext.insightsPageLinkUrl;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _hasInsights = !!insights;
  var _hasSnapshot = !!(insights != null && insights.snapshots) && insights.snapshots.length >= 2;
  var _hasProgress = !!(insights != null && insights.comparisons);
  var _hasFootprint = !!(insights != null && insights.footprintSections);
  var _hasImpacts = !!(insights != null && insights.steps.impacts);
  var _hasGoals = !!(insights != null && insights.steps.goals);
  var _hasClimateClock = !!(insights != null && insights.climateClock);
  var _ItemTemplate = (0, _react.useCallback)(function (_ref2) {
    var item = _ref2.item,
      style = _ref2.style,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    return (0, _jsxRuntime.jsx)(_components.GoalCard, Object.assign({
      testID: "goalCard-".concat(item.slug),
      value: item.value,
      label: item.name,
      Image: goalToSvgMap[item.slug || 'cut_carbon'],
      style: style
    }, props));
  }, [goalToSvgMap]);
  var footprintSections = insights == null ? void 0 : insights.footprintSections;
  var treesItemIndex = footprintSections == null ? void 0 : footprintSections.findIndex(function (item) {
    return item.id === 'trees';
  });
  var treesItem = treesItemIndex !== -1 ? footprintSections == null ? void 0 : footprintSections.splice(treesItemIndex, 1)[0] : null;
  if (treesItem) {
    footprintSections == null ? void 0 : footprintSections.push(treesItem);
  }
  var currentSteps = 0;
  if (_hasImpacts) {
    insights.steps.impacts.forEach(function (impact) {
      currentSteps += impact.value;
    });
  }
  if (isLoading) {
    return (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {});
  }
  if (!_hasInsights) return null;
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(_components.View, {
      style: [styles.container, styles.container_noHeader],
      children: [(0, _jsxRuntime.jsx)(_components.Heading, {
        level: 1,
        style: styles.heading,
        children: t('footprint:title')
      }), (0, _jsxRuntime.jsx)(_components.TabNavigation, {
        style: styles.tabs,
        items: [{
          label: t('footprint:subNavigation.footprints'),
          href: footprintPageLinkUrl
        }, {
          label: t('footprint:subNavigation.insights'),
          href: insightsPageLinkUrl,
          active: true
        }]
      }), (0, _jsxRuntime.jsxs)(_components.View, {
        style: styles.column,
        children: [_hasSnapshot && (0, _jsxRuntime.jsx)(_components.StartingCurrentFootprint, {
          startingFootprint: insights.snapshots[0],
          currentFootprint: insights.snapshots[1],
          style: styles.section
        }), _hasProgress && (0, _jsxRuntime.jsx)(_components.ProgressChart, {
          comparisons: insights.comparisons,
          current: insights.gCo2e,
          style: styles.section
        }), _hasFootprint && (0, _jsxRuntime.jsx)(_components.CarbonFootprintBreakdown, {
          items: updateFootprintData(formatFootprints(footprintSections)),
          style: styles.section
        }), _hasImpacts && (0, _jsxRuntime.jsx)(_components.ImpactsChart, {
          items: updateImpactData(formatImpacts(insights == null ? void 0 : insights.steps.impacts)),
          totalSteps: insights == null ? void 0 : (_insights$steps = insights.steps) == null ? void 0 : (_insights$steps$total = _insights$steps.totals) == null ? void 0 : _insights$steps$total.applicable,
          currentSteps: currentSteps
        })]
      })]
    }), _hasGoals && (0, _jsxRuntime.jsx)(_components.GoalCarousel, {
      items: updateImpactData(formatImpacts(insights == null ? void 0 : insights.steps.goals)),
      ItemTemplate: function ItemTemplate(_ref3) {
        var args = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref3), _ref3));
        return (0, _jsxRuntime.jsx)(_ItemTemplate, Object.assign({}, args));
      },
      style: styles.section
    }), (0, _jsxRuntime.jsx)(_components.View, {
      style: [styles.container, styles.column],
      children: _hasClimateClock && (0, _jsxRuntime.jsx)(_components.ClimateClock, {
        title: 'Your climate clock',
        years: insights == null ? void 0 : insights.climateClock.years,
        months: insights == null ? void 0 : insights.climateClock.months,
        unlimited: insights == null ? void 0 : insights.climateClock.unlimited
      })
    })]
  });
});